import { BodyCaption } from "@/domains/design/components/body-caption"
import { cn } from "@/domains/library"

export const ExternalTxLink = ({
  url,
  title = "View transaction",
  className,
}: {
  url: string
  title?: string
  className?: string
}) => {
  return (
    <BodyCaption className={cn("text-t200", className)}>
      <a href={url} target="_blank" rel="noopener noreferrer" className="underline">
        {title}
      </a>
    </BodyCaption>
  )
}
